/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FechaMinMaxReproModelDto } from '../../models/fecha-min-max-repro-model-dto';

export interface CitasControllerFechaMinMaxReprogramarCita$Params {
}

export function citasControllerFechaMinMaxReprogramarCita(http: HttpClient, rootUrl: string, params?: CitasControllerFechaMinMaxReprogramarCita$Params, context?: HttpContext): Observable<StrictHttpResponse<FechaMinMaxReproModelDto>> {
  const rb = new RequestBuilder(rootUrl, citasControllerFechaMinMaxReprogramarCita.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FechaMinMaxReproModelDto>;
    })
  );
}

citasControllerFechaMinMaxReprogramarCita.PATH = '/api/citas/fecha-min-max-reprogramar-cita';
